(function ($) {
    $.fn.shortTitle = function (target) {
        return this.each(function () {

            $(this).on('keyup.shortTitle', function () {
                var value = $(this).val();
                var short_title = value.replace(/[^a-z0-9\-\_\s]+/ig, '');
                short_title = short_title.replace(/\s+/g, '-', short_title);
                $(target).val(short_title.toLowerCase());
            });

            $(this).on('blur.shortTitle', function () {
                var value = $(this).val();
                var short_title = value.replace(/[^a-z0-9\-\_\s]+/ig, '');
                short_title = short_title.replace(/\s+/g, '-', short_title);
                $(target).val(short_title.toLowerCase());
            });

        });
    };

    // Backwards compatible command for short title
    $.fn.short_title = $.fn.shortTitle;

    $.fn.confirmDelete = function (settings) {
        var defaults = {
            text: 'Confirm?',
            timeout: 3000
        };
        options = $.extend({}, defaults, settings);

        return this.each(function () {
            $(this).on('click', function (e) {
                if (!$(this).data('confirmed')) {
                    // Save old content
                    $(this).data('old-content', $(this).html());

                    // Fade out old text (and icon, if applicable)
                    if ($(this).find('.btn-label').length > 0) {
                        var text = $(this).contents().filter(function() { return this.nodeType === Node.TEXT_NODE; });
                        $(text).each(function () {
                            if (/\w/mg.test($(this).text()) === true) {
                                $(this).wrap('<span class="text">');
                            }
                        });

                        $(this).find('.btn-label i').fadeOut('fast', function () {
                            $(this).parent().html('<i class="glyphicon glyphicon-ok-2"></i>');
                            $(this).parent().find('i').hide();
                            $(this).parent().find('i').fadeIn('fast');
                        });
                    } else {
                        $(this).contents().wrap('<span class="text">');
                    }

                    $(this).find('.text').fadeOut('fast', function () {
                        $(this).text(options.text);
                        $(this).hide();
                        $(this).fadeIn('fast');
                    });

                    // If after a specified amount of time the user has not
                    var that = this;
                    $(this).data('confirmTimer', setTimeout(function () {
                        $(that).data('confirmed', false);
                        $(that).html($(that).data('old-content'));
                    }, options.timeout));

                    $(this).data('confirmed', true);

                    e.stopImmediatePropagation();
                    return false;
                } else {
                    clearTimeout($(this).data('confirmTimer'));
                    $(this).html($(this).data('old-content'));
                    $(this).data('confirmed', false);
                    return true;
                }
            });
        });
    };

    $(document).ready(function () {
        // Check for an outdated browser
        outdatedBrowser();

        // Add Select2 dropdowns for specific select boxes
        $('select[data-select]').select2({
            minimumResultsForSearch: 12
        });

        // Add Confirm Deletion action
        $('[data-delete-confirm]').confirmDelete();

        // Add tooltips
        $('.has-tooltip,*[data-tooltip]').tooltip();

        // Add boolean switches
        $('*[data-boolean-switch]').bootstrapSwitch({
            onColor: 'success',
            offColour: 'normal',
            onText: '<span class="glyphicon glyphicon-ok"></span>',
            offText: '<span class="glyphicon glyphicon-remove"></span>'
        });

        // Add page live toggle
        $('#page-live-toggle').bootstrapSwitch({
            handleWidth: 60
        });
        $('#page-live-toggle').on('switchChange.bootstrapSwitch', function (e, data) {
            var that = this;
            setTimeout(function () {
                document.location.href = '/cms/pages/toggle_live/' + $(that).data('location');
            }, 600);
        });
    });
}(jQuery));

function abWebTabs () {
    $('ul.nav-tabs a').focus(function () {
        $(this).trigger('click');

        return false;
    });

    $('ul.nav-tabs a').click(function (e) {
        var input = $('#' + $(this).attr('href').replace('#', '')).find('input,select,textarea,button').filter(':visible,:first');

        if ($(this).parent().hasClass('active') == false) {
            setTimeout(function () {
                $(input).focus();
            }, 200);
        }

        // Set hash so we can go to this tab on refresh
        window.location.hash = 't-' + $(this).attr('href').replace('#', '');

        e.preventDefault();
    });

    $('.next').click(function () {
        $('.nav-tabs li.active').next().find('a').trigger('click');
        return false;
    });

    if (/t\-[a-zA-Z0-9\-\_]+/.test(window.location.hash) === true) {
        var tab = /t\-([a-zA-Z0-9\-\_]+)/.exec(window.location.hash);
        $('ul.nav-tabs a[href="#' + tab[1] + '"]').trigger('click');
    }
}
